import { render, staticRenderFns } from "./Retours.vue?vue&type=template&id=4e9fd088&scoped=true&lang=true&"
import script from "./Retours.vue?vue&type=script&lang=js&"
export * from "./Retours.vue?vue&type=script&lang=js&"
import style0 from "./Retours.vue?vue&type=style&index=0&id=4e9fd088&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e9fd088",
  null
  
)

export default component.exports